import { useState } from "react";
import "./editorialForms.css";

export default function LiveStreamForm({ data, onChange }) {
  const [tags, setTags] = useState(data?.tags?.join(", ") || "");

  const handleTagsChange = (e) => {
    const value = e.target.value;
    setTags(value);
    const tagsArray = value
      .split(",")
      .map((t) => t.trim())
      .filter((t) => t.length > 0);
    onChange({ ...data, tags: tagsArray });
  };

  const categories = [
    "Just Chatting",
    "Gaming",
    "Musica",
    "Arte",
    "Educacao",
    "Tecnologia",
    "Culinaria",
    "Fitness",
    "Talk Show",
    "Podcast",
    "Noticias",
    "Eventos",
  ];

  return (
    <div className="editorial_form live_stream_form">
      <div className="editorial_form_section">
        <label>
          Titulo da Live <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Live de sexta-feira!"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
          maxLength={140}
        />
        <span className="editorial_form_counter">
          {(data?.title?.length || 0)}/140
        </span>
      </div>

      <div className="editorial_form_section">
        <label>Descricao</label>
        <textarea
          placeholder="Sobre o que sera a live..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={1000}
          rows={3}
        />
      </div>

      <div className="editorial_form_section">
        <label>Categoria</label>
        <select
          value={data?.category || "Just Chatting"}
          onChange={(e) => onChange({ ...data, category: e.target.value })}
        >
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <label>Tags (separadas por virgula)</label>
        <input
          type="text"
          placeholder="entretenimento, conversa, diversao"
          value={tags}
          onChange={handleTagsChange}
        />
      </div>

      <div className="editorial_form_section">
        <label>Configuracoes da Live</label>
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="isMature"
              checked={data?.isMature || false}
              onChange={(e) =>
                onChange({ ...data, isMature: e.target.checked })
              }
            />
            <label htmlFor="isMature">Conteudo para maiores de 18 anos</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="chatEnabled"
              checked={data?.chatEnabled !== false}
              onChange={(e) =>
                onChange({ ...data, chatEnabled: e.target.checked })
              }
            />
            <label htmlFor="chatEnabled">Chat habilitado</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="slowMode"
              checked={data?.slowMode || false}
              onChange={(e) =>
                onChange({ ...data, slowMode: e.target.checked })
              }
            />
            <label htmlFor="slowMode">Modo lento no chat</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="saveRecording"
              checked={data?.saveRecording !== false}
              onChange={(e) =>
                onChange({ ...data, saveRecording: e.target.checked })
              }
            />
            <label htmlFor="saveRecording">Salvar gravacao apos a live</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip live_stream_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
        </svg>
        <span>
          Inicie uma transmissao ao vivo para interagir com seus seguidores em
          tempo real. Configure as opcoes antes de comecar.
        </span>
      </div>

      <div className="editorial_form_section">
        <div className="live_stream_actions">
          <div className="live_info_box">
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
            </svg>
            <div>
              <strong>Como iniciar:</strong>
              <p>Apos publicar, voce podera iniciar a transmissao usando seu software de streaming (OBS, Streamlabs, etc.) com a chave fornecida.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
